import React from "react";
import { useNavigate } from "react-router";
import { DealsContext } from "@Src/routes/deals/Deals.context";
import CouponHeader from "./CouponHeader";
import OfferDetail from "./OfferDetail";
import OfferPhotos from "./OfferPhotos";
import Locations from "./Locations";
import { useSelector } from "react-redux";
import { selectors } from "@Src/redux/reducers";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import FavoriteThis from "@Src/components/FavoriteThis";
const { getStoreLocation } = selectors;

export default function ScreenLocationDeals() {
  const context = React.useContext(DealsContext);
  const contextRef = React.useRef(context);
  const navigate = useNavigate();
  const [currentStore] = React.useState(useSelector(getStoreLocation));
  React.useEffect(() => {
    contextRef.current.setCurrentStore(currentStore);
  }, [currentStore]);

  if (!context.store) return null;

  const allLocations = [currentStore.closest_location, ...(currentStore.locations || [])];

  const selectLocation = (location) => {
    contextRef.current.setSelectedLocation(location);
  };

  const shouldShowMoreLocations = allLocations.length > 1;

  return (
    <div className="ScreenLocationDeals">
      {context.selectedLocation && context.selectedLocation.offers ? (
        <>
          <FavoriteThis
            name={context?.store?.name}
            id={context?.store?.store_key}
            className="offer-fav-widget__favorite"
          />
          <CouponHeader />
          <button
            className="offer-detail__focus-target"
            aria-label={t`Offers for ${context.store.name}`}
            onBlur={(evt) => {
              // This is the initial focus target for screen readers
              // Ensure it doesn't get focused again on blur
              evt.target.setAttribute("tabIndex", "-1");
            }}
          />
          <div className="offer-detail__content">
            <Locations
              selectLocation={selectLocation}
              shouldShowMoreLocations={shouldShowMoreLocations}
              selectedLocation={context.selectedLocation}
              allLocations={allLocations}
              store={context.store}
            />
            {context.selectedLocation.offers.map((offer) => (
              <OfferDetail
                key={offer.offer_key}
                offer={offer}
                member={context.member}
                store_key={context.store.store_key}
                navigate={navigate}
              />
            ))}
            {!!context.selectedLocation.brand_photos?.PHOTO && (
              <OfferPhotos photos={context.selectedLocation.brand_photos.PHOTO} />
            )}
          </div>
        </>
      ) : (
        <div>
          <Trans>Loading...</Trans>
        </div>
      )}
    </div>
  );
}
